import React, { FC } from 'react';

import { Modal, Props as ModalProps } from './index';

export type Props = {} & ModalProps;

export const SqueezedModal: FC<Props> = (props) => {
  return (
    <Modal variant='squeezed' {...props}>
      <div className='modal-title mb-mini'>
        <span className='icon-share icon mr-mini' />
        Share
      </div>
      <div>{props.children}</div>
      <div className='mt-2 text-center'>
        <button onClick={props.onRequestClose} className='btn btn--border'>
          Close
        </button>
      </div>
    </Modal>
  );
};
